import React, { useState, useEffect, useCallback, useMemo } from 'react';
import SidebarCategory from './SidebarCategory';
import buildCategoryHierarchy from '../helpers/buildCategoryHierarchy';


const CategoryList = () => {
    const [loadingCollection, setLoadingCollection] = useState(true);
    const [error, setError] = useState(null);
    const [collections, setCollections] = useState([]);
    const hierarchicalCollections = useMemo(() => buildCategoryHierarchy(collections), [collections]);
    const renderCategoryChildrenRef = useCallback((category, depth = 1) => {
        return (
            <li
                key={category.id}
            >
                <SidebarCategory
                    title={category.title}
                    isExpanded={false}
                    handle={category.handle}
                    depth={depth}
                >
                    {category.children && category.children.length > 0 ? category.children.map((child) => renderCategoryChildrenRef(child, depth + 1)) : null}
                </SidebarCategory>
            </li>
        );
    }, []);

    const fetchCollections = useCallback(async () => {
        try {
            setLoadingCollection(true);
            const url = new URL('/api/collections/index', process.env.APP_URL);
            const response = await fetch(url);
            const data = await response.json();
            setCollections(data.collections);
            setLoadingCollection(false);
        } catch (e) {
            setError(e.message);
            setLoadingCollection(false);
        }
    }, []);

    useEffect(() => {
        fetchCollections();
    }, []);

    if (loadingCollection) {
        return (
            <div
                className={'p-2'}>Loading categories...</div>
        );
    } else if (error) {
        return (
            <div
                className={'p-2'}>Error loading categories: {error}</div>
        );
    }
    return (
        <div
            style={{ border: '1px solid #e1e1e1' }}
        >
            <h3
                className={'dotted-background'}
            >CATEGORIES</h3>
            {hierarchicalCollections.map((category) => (
                <SidebarCategory
                    key={category.id}
                    title={category.title}
                    isExpanded={false}
                    handle={category.handle}
                    depth={0}
                >
                    {category.children.map((child) => renderCategoryChildrenRef(child))}
                </SidebarCategory>
            ))}
        </div>
    );
};

export default CategoryList;